import React from 'react';

const Gallery = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white py-20 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4">Coming Soon</h1>
        <p className="text-xl text-gray-700">
          Our gallery is currently under construction. Check back soon for exciting updates!
        </p>
      </div>
    </div>
  );
};

export default Gallery; 